
<div class="{{circleClassName}}">
  <div class="header">
      <itb-text [className]="'text-default'" [text]="title"></itb-text>
  </div>  
  <div class="itb-progress-circle" [attr.data-progress]="percentage | number: '1.0-0'" (click)="clickEvent()" >
    <div class="itb-circle">
      <div class="full itb-progress-circle__slice" >
        <div class="itb-progress-circle__fill"></div>
      </div>
      <div class="itb-progress-circle__slice">
        <div class="itb-progress-circle__fill"></div>
        <div *ngIf="isTooltip" class="itb-progress-circle__fill itb-progress-circle__bar" matTooltip=" {{percentage | number: '1.0-1'}}% " [matTooltipPosition]="'above'" matTooltipClass="circle-progress-tooltip"></div>
        <div *ngIf="!isTooltip" class="itb-progress-circle__fill itb-progress-circle__bar" ></div>
      </div>
    </div>
    <div class="itb-progress-circle__overlay" [ngClass]="{'with-icon': percentImageClass && percentProgress}">
        <span *ngIf="percentImageClass && percentProgress">
            <itb-icon [className]="percentImageClass" ></itb-icon>
        </span>
        <span *ngIf="!percentProgress" class="perc">{{ progress | number: '1.0-1'}}</span>
        <span *ngIf="percentProgress" class="perc"   >{{ progress | number: '1.0-1'}}%</span>
        <span class="text">{{ innerTitle }} {{score}}</span>
    </div>
  </div>
</div>

